import { RadioGroup } from '../../../../../components/RadioGroup';
import { SettingItemList } from '../../SettingItemList';
import { DynamicForm } from '../../DynamicForm';
import { useCreateOperator } from '../../../../../contexts/CreateOperatorContext';
import { Package } from './Package';
import React from 'react';

export const Packages = () => {
  const { operator, updateOperator } = useCreateOperator();
  const classes = useStyles();

  const handleRemovePkg = (pkgIndex: number) => {
    updateOperator(
      'subscriberGroups',
      operator.subscriberGroups.filter((value, index) => index !== pkgIndex)
    );
  };

  const handleSavePkg = (item: CreateOperatorPackage, pkgIndex: number) => {
    updateOperator(
      'subscriberGroups',
      operator.subscriberGroups.map((value, index) => {
        if (index === pkgIndex) return item;
        return value;
      })
    );
  };

  return (
    <div className={classes.container}>
      <DynamicForm<CreateOperatorPackage>
        defaultForm={{ active: true, description: '', name: '', type: null }}
        inputs={[
          {
            order: 0,
            rowInputs: [
              {
                props: {
                  name: 'description',
                  label: 'Package Name',
                  required: false, // TODO: Disabling for now, Original setting: true,
                  value: (values) => values.description,
                },
              },
              {
                props: {
                  name: 'name',
                  label: 'Subscriber Group',
                  required: false, // TODO: Disabling for now, Original setting: true,
                  value: (values) => values.name,
                },
              },
            ],
          },
          {
            order: 1,
            rowInputs: [
              {
                customInput: (values, updateField) => (
                  <RadioGroup
                    label="Package Type"
                    options={[
                      {
                        label: 'Base',
                        order: 1,
                        value: 'base',
                      },
                      {
                        label: 'Add-On',
                        order: 2,
                        value: 'addons',
                      },
                      {
                        label: 'À La Carte',
                        order: 3,
                        value: 'alaCarte',
                      },
                    ]}
                    // TODO: Disabling for now, Original setting: required
                    padding="sm"
                    spacing="start"
                    selection={values.type ?? ''}
                    onChange={(event) =>
                      updateField('type', event.target.value)
                    }
                  />
                ),
              },
            ],
          },
        ]}
        submitButton={{ text: 'Add Package' }}
        validation={(values) =>
          values.name.trim() !== '' &&
          values.description.trim() !== '' &&
          values.type !== null
        }
        onSubmit={(values) =>
          updateOperator('subscriberGroups', [
            values,
            ...operator.subscriberGroups,
          ])
        }
      />
      <SettingItemList<CreateOperatorPackage>
        name="Packages"
        items={operator.subscriberGroups}
        renderRow={(item, index) => (
          <Package
            index={index}
            subscriberGroup={item}
            onRemove={handleRemovePkg}
            onSave={handleSavePkg}
          />
        )}
      />
    </div>
  );
};

const useStyles = () => ({
  container: 'flex flex-col gap-4 items-center',
  inputs: 'inline-flex items-center gap-4',
});
